import {CurrencyPipe, DatePipe} from '@angular/common';
import {ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalController, NavController} from '@ionic/angular';

import {
  AccountPaymentRechargeBilletResponse,
  BilletService,
  BilletStatusEnum,
  BilletTypeEnum,
  ImmediateDischargeBilletRequestDto
} from '@wlp/ui-bs-cashin';
import {UserInfoService} from '@wlp/ui-bs-login';
import {StorageService} from '@wlp/ui-bs-oauth';
import {Paginated, PaginationParams} from '@wlp/ui-bs-parameter';
import {UiBsTranslateService} from '@wlp/ui-bs-translate';

import {BilletDto} from '@wlp/ui-px-cashin';
import {BrMaskDirective} from 'br-mask';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import {LayoutConfigModel} from 'src/app/core/layout/models/layout-config.model';
import {LayoutConfigService} from 'src/app/core/layout/services/layout-config.service';
import {
  ModalAlertBilletComponent
} from 'src/app/views/themes/sentinel/modals/modal-alert-billet/modal-alert-billet.component';
import {ModalAlertComponent} from 'src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component';
import {
  ModalBilletAlertCancelComponent
} from 'src/app/views/themes/sentinel/modals/modal-billet-alert-cancel/modal-billet-alert-cancel';
import {
  ModalBilletReviewChargingComponent
} from 'src/app/views/themes/sentinel/modals/modal-billet-review-charging/modal-billet-review-charging.component';
import {
  ModalBilletViewDetailV2Component
} from 'src/app/views/themes/sentinel/modals/modal-billet-view-detail-v2/modal-billet-view-detail-v2.component';
import {ModalTokenComponent} from 'src/app/views/themes/sentinel/modals/modal-token/modal-token.component';
import {environment} from 'src/environments/environment';
import {LoadingService} from '../../../../../../../../../core/layout/services/loading.service';
import {ExtractUtil} from '../../../extract/extract-util';
import {ExtractUtilInterface} from '../../../extract/extract-util.interface';
import {BilletManagementDataFilterPipe} from './billet-management-data-filter.pipe';
import {FilterLot} from '../../../../cash-in/billing/components/filter-lot/filter-lot';

type EditFieldOptions = 'document' | 'dueDate' | 'nominalValue' | 'discount' | 'fees' | 'fines' | 'paymentDeadline' | 'protest' | 'payer' | 'abatement';

type TypeOrigin = 'extract';

@Component({
  selector: 'ui-t-billet-management',
  templateUrl: './billet-management.page.html',
  styleUrls: ['./billet-management.page.scss'],
  providers: [BilletManagementDataFilterPipe, CurrencyPipe],
})
export class CharginBilletManagementPage extends ExtractUtil implements ExtractUtilInterface, OnInit {

  @ViewChild(FilterLot, { static: false }) public filterLot: FilterLot;
  @ViewChild(`summaryContainers`, {static: false}) public summaryContainers: ElementRef;

  public pendingValue: number = 0;
  public pendingQuantity: number = 0;
  public compensatedValue: number = 0;
  public compensatedQuantity: number = 0;
  public canceledValue: number = 0;
  public canceledQuantity: number = 0;
  public overdueValue: number = 0;
  public overdueQuantity: number = 0;

  public status: BilletStatusEnum;
  public moreActionsMenuIsOpen = {
    index: null,
    isOpen: false,
  };

  private langDefault: string;
  private readonly OPERATION: string = '1002';
  private layoutConfigValue: LayoutConfigModel;
  public isProd: boolean = environment.production;
  public uuidLotBillet: string;
  lot: any;

  public itemsPerPageOptions: number[] = [10, 20, 30, 50, 100];
  public itemsPerPage: number = 10;
  public iconSkipLast = './assets/icon/icon-material-skip-last.svg';
  public iconNavigateLast = './assets/icon/icon-material-navigate-last.svg';
  public iconNavigateNext = './assets/icon/icon-material-navigate-next.svg';
  public iconSkipNext = './assets/icon/icon-material-skip-next.svg';

  public startDateSelected = this.today.subtract(7, 'days').format('YYYY-MM-DD');

  public billets: BilletDto[];
  public billetsPaginated: Paginated<BilletDto[]> = null;
  public billetsToDisplay: BilletDto[];

  public typeOrigin: TypeOrigin = null;
  public dateStartFromQuery: string = null;
  public dateEndFromQuery: string = null;
  public statusSelected: BilletStatusEnum;

  constructor(
    public pipeFilter: BilletManagementDataFilterPipe,
    public pipeCurency: CurrencyPipe,
    public detection: ChangeDetectorRef,
    private accountChargingService: BilletService,
    protected userInfoService: UserInfoService,
    public modalController: ModalController,
    public activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    public loadingService: LoadingService,
    private layoutConfigService: LayoutConfigService,
    private navCtrl: NavController,
    private translate: UiBsTranslateService,
    private storage: StorageService,
    public brMask: BrMaskDirective,
    public router: Router,
    private route: ActivatedRoute,
    /* private crd: ChangeDetectorRef */
  ) {
    super(userInfoService, pipeFilter, detection, modalController, loadingService);
  }

  get today() {
    return moment().clone();
  }

  public async ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

    this.route.queryParams.subscribe(params => {
      this.statusSelected = params['status'];
      this.dateStartFromQuery = params['startDate'];
      this.dateEndFromQuery = params['endDate'];
      this.typeOrigin = params['typeOrigin'];
    });
  }

  async ionViewWillEnter() {
    this.loadingService.show();

    if (!this.userProfile) {
      await this.loadUser();
    }
    this.getBilletsOnInit();
    this.getTotalByStatus()

    this.loadingService.hide();
  };

  public async getTotalByStatus(status?: BilletStatusEnum | '') {
    let type = BilletTypeEnum.CHARGING;

    const {startDate, endDate } = this.getValuesFromForm()

    if(status === '' || status === undefined) {
      const allSummaryStatus = [BilletStatusEnum.COMPENSATED, BilletStatusEnum.PENDING, BilletStatusEnum.CANCELED, BilletStatusEnum.OVERDUE]
    
      allSummaryStatus.forEach(item => {
        this.accountChargingService
        .getAllStatusDataByStatus(this.userProfile.uuidAccount, type, item, startDate, endDate)
        .subscribe(
          (res) => {
            switch (item) {
              case 'PENDING': {
                this.pendingValue = res.totalValue;
                this.pendingQuantity = res.quantity;
                break;
              }
              case 'CANCELED': {
                this.canceledValue = res.totalValue;
                this.canceledQuantity = res.quantity;
                break;
              }
              case 'COMPENSATED': {
                this.compensatedValue = res.totalValue;
                this.compensatedQuantity = res.quantity;
                break;
              }
              case 'OVERDUE': {
                this.overdueValue = res.totalValue;
                this.overdueQuantity = res.quantity;
                break;
              }
            }
          },
          (err) => console.error(err),
        );
      })
    } else {
        this.accountChargingService
        .getAllStatusDataByStatus(this.userProfile.uuidAccount, type, status, startDate, endDate)
        .subscribe(
          (res) => {
            switch (status) {
              case 'PENDING': {
                this.pendingValue = res.totalValue;
                this.pendingQuantity = res.quantity;
                break;
              }
              case 'CANCELED': {
                this.canceledValue = res.totalValue;
                this.canceledQuantity = res.quantity;
                break;
              }
              case 'COMPENSATED': {
                this.compensatedValue = res.totalValue;
                this.compensatedQuantity = res.quantity;
                break;
              }
              case 'OVERDUE': {
                this.overdueValue = res.totalValue;
                this.overdueQuantity = res.quantity;
                break;
              }
            }
          },
          (err) => console.error(err),
        );
    }
  }

  public async validateTokenManualCheckout(billet: BilletDto) {
    const modalTokenManualCheckout = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
        confirmation: true,
      },
      backdropDismiss: false,
    });

    modalTokenManualCheckout.onDidDismiss().then((data) => {
      if (data !== undefined) {
        this.billetManualCheckout(billet, data.role)
      }
    });

    return await modalTokenManualCheckout.present();
  }

  public billetManualCheckout(billet: BilletDto, codeAuthorization: string) {
    const body: ImmediateDischargeBilletRequestDto[] = [{
      uuidBillet: billet.uuid,
      body: {
        codeAuthorization: codeAuthorization,
        transactionId: billet.transactionId,
        uuidWhitelabel: this.userProfile.uuidWhiteLabel,
      },
    }];

    this.accountChargingService.immediateDischargeBillet(body).subscribe(
    res => this.statusNotificationManualCheckout('success', 'CASH_OUT.MODAL_ALERT.ALERT3', true),
    err => this.statusNotificationManualCheckout('warning-circle', 'CASH_OUT.MODAL_ALERT.FAILED_IMMEDIATE_DISCHARGE_OPERATION', true),
    async () =>  {
        this.loadingService.show();

        this.getTotalByStatus();

        const {startDate, endDate, status, searchKey} = this.getValuesFromForm();
        await this.getBilletsWithFiler(startDate, endDate, status, searchKey);
        this.startDateSelected = startDate;

        this.loadingService.hide()
     }
    );
  }

  private async statusNotificationManualCheckout(status: string, message: string, translateFlag: boolean) {
    this.loadingService.hide();
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: message,
        confirmBtn: 'CASH_OUT.ACCOUNT_CHARGING.CLOSE_BUTTON',
        translate: translateFlag,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }

  public async cancelAlert(uuidBillet: string, transactionId: string, index: number) {
    this.moreActionsMenuIsOpen = {
      index: index,
      isOpen: false,
    };
    
    const modalToken = await this.modalController.create({
      component: ModalBilletAlertCancelComponent,
      cssClass: 'modal-billet-alert-cancel',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
        confirmation: true,
        confirm: () => this.validateToken(uuidBillet, transactionId),
        title: 'CASH_OUT.MODAL_CANCEL.TITLE',
        description: 'CASH_OUT.MODAL_CANCEL.DESCRIPTION',
        alert1: 'CASH_OUT.MODAL_CANCEL.ALERT1',
        alert2: 'CASH_OUT.MODAL_CANCEL.ALERT2',
        confirmBtn: 'CASH_OUT.MODAL_CANCEL.BUTTON1',
        cancelBtn: 'CASH_OUT.MODAL_CANCEL.BUTTON2'
      },
      backdropDismiss: false,
    });
    return await modalToken.present();
  }

  public async validateToken(uuidBillet: string, transactionId: string) {
    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
        confirmation: true,
      },
      backdropDismiss: false,
    });
    modalToken.onDidDismiss().then((data) => {
      const codeAuthorization = data.role

      const cancelBilletBody = [{
        uuidBillet,
        body: {
          transactionId: transactionId,
          uuidWhitelabel: this.userProfile.uuidWhiteLabel,
          codeAuthorization: codeAuthorization
        }
      }]

      this.accountChargingService.cancelBillet(cancelBilletBody).subscribe(
        res => this.statusNotificationManualCheckout('success', 'CASH_OUT.MODAL_ALERT.ALERT3', true),
        err => this.statusNotificationManualCheckout('warning-circle', 'CASH_OUT.MODAL_ALERT.FAILED_CANCEL_OPERATION', true),
        async () =>  {
          this.loadingService.show();

          this.getTotalByStatus()

          const {startDate, endDate, status, searchKey} = this.getValuesFromForm()
      
          await this.getBilletsWithFiler(startDate, endDate, status, searchKey);
      
          this.startDateSelected = startDate;
        }
      )
    });
    return await modalToken.present();
  }

  public openMoreActionMenu(i) {
    this.moreActionsMenuIsOpen = {
      index: i,
      isOpen: !this.moreActionsMenuIsOpen.isOpen,
    };
  }

  ionViewWillLeave() {
    this.storage.remove('uuidLotBillet');
  }

  async filterByStatus(summaryItem: string, status: BilletStatusEnum) {
    this.loadingService.show();

    const allCssSummaryBoxes = []
    let summaryContainer: HTMLElement;
    summaryContainer = (this.summaryContainers.nativeElement as HTMLElement);

    const summaryBox: NodeListOf<HTMLElement> = summaryContainer.querySelectorAll('.card-info-border');
    const summaryItemSelected: HTMLElement = summaryContainer.querySelector(summaryItem);
    
    const {startDate, endDate, searchKey} = this.getValuesFromForm()

    summaryBox.forEach(btn => {
      if (btn.classList.contains('selected')) {
        allCssSummaryBoxes.push(btn.classList.value)
      }
    })
    
    if (allCssSummaryBoxes.length === 4 || !summaryItemSelected.classList.contains('selected')) {
      summaryBox.forEach((btn) => btn.classList.remove('selected'));

      summaryItemSelected.classList.add('selected')

      const formFilter = this.filterLot.formFilter
      formFilter.selectStatus(status)
      formFilter.filterLotForm.get('status').setValue(status)
      this.statusSelected = status

      await this.getBilletsWithFiler(startDate, endDate, status, searchKey);

    } else {
      summaryBox.forEach((btn) => btn.classList.add('selected'));

      const formFilter = this.filterLot.formFilter
      formFilter.selectStatus(status)
      formFilter.filterLotForm.get('status').setValue('')
      this.statusSelected = '' as BilletStatusEnum

      await this.getBilletsWithFiler(startDate, endDate);      
    }
  }

  showQuantity(quantity: any) {
    const param = {
      amount: quantity > 0 ? quantity : 0,
    };
    return param;
  }

  private async getBilletsOnInit() {
    this.loadingService.show();

    const initialDate = this.calInitialDate;
    this.dateExtractInit = moment(initialDate);
    this.dateExtractEnd = moment(this.calEndDate);

    let dateInitial = new DatePipe('en-US').transform(this.formattedDate(initialDate), 'yyyy-MM-dd');
    let dateEnd = new DatePipe('en-US').transform(this.formattedDate(this.calEndDate), 'yyyy-MM-dd');

    if (this.dateStartFromQuery) {
      dateInitial = this.dateStartFromQuery;
    }
    if (this.dateEndFromQuery) {
      dateEnd = this.dateEndFromQuery;
    }

    if (this.statusSelected === BilletStatusEnum.COMPENSATED) {
      this.filterLot.searchDays.resetBtnFilters();
    }
    this.filterLot.formFilter.filterLotForm.get('startDate').setValue(moment(dateInitial).format('DD/MM/YYYY'))
    this.filterLot.formFilter.filterLotForm.get('endDate').setValue(moment(dateEnd).format('DD/MM/YYYY'))
    this.filterLot.formFilter.filterLotForm.get('status').setValue('')
    this.filterLot.formFilter.selectStatus(this.statusSelected);

    await this.getBilletsWithFiler(dateInitial, dateEnd, this.statusSelected);
  }

  private async getBilletsWithFiler(startDate?: string, endDate?: string, status?: BilletStatusEnum, searchText?: string, paginationParams?: PaginationParams) {
    if (!paginationParams) {
      paginationParams = new PaginationParams(1, this.itemsPerPage);
    }
    try {
      this.billetsPaginated = await this.accountChargingService.getChargingBilletsPaginated(startDate, endDate, status, searchText, paginationParams).toPromise();
      this.billets = this.billetsPaginated.data as BilletDto[];
      this.billetsToDisplay = this.billets;

      this.getTotalByStatus(status);
    } catch (error) {
      console.error(error);
    } finally {
      this.loadingService.hide();
      this.cdr.detectChanges();
    }
  }

  checkStatus(status) {
    if (status) {
      return 'Vencido';
    } else {
      return 'Válido';
    }
  }

  getTransaction(transactionId: string) {
    this.accountChargingService.getBilletsByTransactionId(transactionId).subscribe((res) => {
      this.showExtract(res);
    });
  }

  async showExtract(data: AccountPaymentRechargeBilletResponse) {
    let billetForm = {
      dateDue: moment(this.formattedDate(data.billetDueTime)).format('DD/MM/YYYY'),
      document: data.documentPayer,
      nameComplete: data.namePayer,
      descripiton: data.requestDescription,
      billetValue: data.value,
    };
    const modal = await this.modalController.create({
      component: ModalBilletReviewChargingComponent,
      cssClass: 'modal-custom-class',
      componentProps: {
        billetRequest: false,
        billet: billetForm,
        billetResponse: data,
        data: data,
      },
      backdropDismiss: false,
    });
    return await modal.present();
  }

  async showCanceled(data: AccountPaymentRechargeBilletResponse) {
    let billetForm = {
      dateDue: moment(this.formattedDate(data.billetDueTime)).format('DD/MM/YYYY'),
      document: data.documentPayer,
      nameComplete: data.namePayer,
      descripiton: data.requestDescription,
      billetValue: data.value,
    };
    const modal = await this.modalController.create({
      component: ModalAlertBilletComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        titleBtnConfirm: 'CASH_OUT.ACCOUNT_RECHARGE_REVIEW_CHARGING.BUTTON.CANCEL',
        message: 'Deseja cancelar o boleto?',
      },
      backdropDismiss: false,
    });
    return await modal.present();
  }

  statusColor(status: BilletStatusEnum) {
    switch (status) {
      case 'PENDING':
        return 'text-pending';
      case 'COMPENSATED':
      case 'PAID':
        return 'text-compensated';
      case 'MANUAL_COMPENSATION':
        return 'text-manual-compensation';
      case 'DRAFT':
      case 'LIMIT_OPERATION':
        return 'text-draft';
      case 'CANCELED':
      case 'ERROR':
      case 'OVERDUE':
        return 'text-canceled';
      default:
        return 'text-default';
    }
  }

  statusLabel(status: BilletStatusEnum) {
    switch (status) {
      case 'PENDING':
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.PENDING');
      case 'COMPENSATED':
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.COMPENSATED');
      case 'PAID':
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.PAID');
      case 'MANUAL_COMPENSATION':
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.MANUAL_COMPENSATION');
      case 'DRAFT':
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.DRAFT');
      case 'CANCELED':
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.CANCELED');
      case 'OVERDUE':
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.OVERDUE');
      case 'LIMIT_OPERATION':
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.LIMIT_OPERATION');
      case 'ERROR':
        return this.translate.applyTranslate('CASH_OUT.BILLET_VIEW_DETAIL.TABLE.STATUS.ERROR');
      default:
        return status;
    }

  }

  goBack() {
    if (this.typeOrigin === 'extract') {
      this.router.navigate(['/app/extract/consolidaded/current'], {
        queryParams: {
          typeOrigin: '', 
          startDate: this.dateStartFromQuery, 
          endDate: this.dateEndFromQuery,
        },
      });
    } else {
      this.navCtrl.navigateRoot('/app/dashboard');
    }
  }

  public async viewDetail(uuid: string) {
    const modalToken = await this.modalController.create({
      component: ModalBilletViewDetailV2Component,
      cssClass: 'modal-view-detail',
      componentProps: {
        uuid
      },
      backdropDismiss: false,
    });
    return await modalToken.present();
  }

  public async manualCheckout(billet: BilletDto, index: number) {
    this.moreActionsMenuIsOpen = {
      index: index,
      isOpen: false,
    };

    const modalManualCheckout = await this.modalController.create({
      component: ModalBilletAlertCancelComponent,
      cssClass: 'modal-billet-alert-cancel',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION,
        confirmation: true,
        confirm: () => this.validateTokenManualCheckout(billet),
        title: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.TITLE',
        description: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.DESCRIPTION',
        alert1: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.ALERT1',
        alert2: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.ALERT2',
        confirmBtn: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.BUTTON1',
        cancelBtn: 'CASH_OUT.MODAL_MANUAL_CHECKOUT.BUTTON2'
      },
      backdropDismiss: false,
    });
    return await modalManualCheckout.present();
  }

  public downloadXlsx(searchText?: string) {

    const {startDate, endDate, searchKey, status} = this.getValuesFromForm();

    this.accountChargingService.getExportXlsx(
      startDate || this.dateExtractInit.format('YYYY-MM-DD'),
      endDate || this.dateExtractEnd.format('YYYY-MM-DD'),
      status || this.status,
      searchKey || this.searchText
    ).subscribe((res) => {
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
      FileSaver.saveAs(blob, `Boletos_${this.userProfile.nameFirst}_${this.dateExtractInit.format('DD-MM-YYYY')}_${this.dateExtractEnd.format('DD-MM-YYYY')}.xlsx`);
    });
  }
  public goToEditPage(uuidBillet: string, field: EditFieldOptions) {
    this.moreActionsMenuIsOpen = { index: null, isOpen: false };
    const urlTarget = `/app/charging/billet/v2/edit/${uuidBillet}`;
    this.loadingService.show();
    this.navCtrl.navigateRoot([urlTarget], {
      queryParams: {
        editType: field,
        typeOrigin: 'list',
      },
    });
  }

  public redirectToExtract(dateCompensate: string) {
    const typeOrigin = 'billet';
    const startDate = dateCompensate ? dateCompensate.split('T')[0] : dateCompensate;
    const endDate = dateCompensate ? dateCompensate.split('T')[0] : dateCompensate;

    this.router.navigate(['/app/extract/consolidaded/current'], {
      queryParams: { typeOrigin, startDate, endDate },
    });
  }

  getValuesFromForm() {
    const {filterLotForm} = this.filterLot.formFilter
    const status = filterLotForm.get('status').value || '';
    const searchKey = filterLotForm.get('searchKey').value || '';
    let startDate = filterLotForm.get('startDate').value || '';
    let endDate = filterLotForm.get('endDate').value || '';

    if (endDate.includes('/')) {
      endDate = moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    if (startDate.includes('/')) {
      startDate = moment(startDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    return { status, searchKey, startDate, endDate }
  }

  async handleClickSearch() {
    this.loadingService.show();
    const {startDate, endDate, status, searchKey} = this.getValuesFromForm()

    await this.getBilletsWithFiler(startDate, endDate, status, searchKey);

    this.startDateSelected = startDate;
  }
  async handleClickSearchForDays(numberDays: number) {
    this.loadingService.show();

    const today = moment();
    const start = today.subtract(numberDays, 'days')
    const end = new Date()

    let dateInitial = new DatePipe('en-US').transform(this.formattedDate(start), 'yyyy-MM-dd');
    let dateEnd = new DatePipe('en-US').transform(this.formattedDate(end), 'yyyy-MM-dd');

    this.filterLot.formFilter.filterLotForm.get('startDate').setValue(moment(dateInitial).format('DD/MM/YYYY'))
    this.filterLot.formFilter.filterLotForm.get('endDate').setValue(moment(dateEnd).format('DD/MM/YYYY'))
    this.filterLot.formFilter.filterLotForm.get('status').setValue('')
    this.filterLot.formFilter.selectStatus(this.statusSelected);

    await this.getBilletsWithFiler(dateInitial, dateEnd, this.statusSelected);

    this.loadingService.hide();
  }
  async handleChangeItemsPerPage(itemsPerPage: number) {
    this.loadingService.show();

    this.itemsPerPage = itemsPerPage;
    const paginationParams = new PaginationParams(0, itemsPerPage);
    const {startDate, endDate, searchKey, status} = this.getValuesFromForm()
    await this.getBilletsWithFiler(startDate || this.startDateSelected, endDate, status, searchKey, paginationParams);
  }
  async handleGoToFirstPage() {
    this.loadingService.show();

    const paginationParams = new PaginationParams(1, this.itemsPerPage)
    const {startDate, endDate, searchKey, status} = this.getValuesFromForm()
    await this.getBilletsWithFiler(startDate || this.startDateSelected, endDate, status, searchKey, paginationParams);
  }
  async handleGoToLastPage() {
    this.loadingService.show();

    const lastPage = this.billetsPaginated ? this.billetsPaginated.pagination.totalPages : 0;
    const paginationParams = new PaginationParams(lastPage, this.itemsPerPage)
    const {startDate, endDate, searchKey, status} = this.getValuesFromForm()
    await this.getBilletsWithFiler(startDate || this.startDateSelected, endDate, status, searchKey, paginationParams);
  }
  async handleGoToNextPage() {
    this.loadingService.show();

    const next = this.billetsPaginated ? this.billetsPaginated.pagination.page + 1 : 0;
    const paginationParams = new PaginationParams(next, this.itemsPerPage)
    const {startDate, endDate, searchKey, status} = this.getValuesFromForm()
    await this.getBilletsWithFiler(startDate || this.startDateSelected, endDate, status, searchKey, paginationParams);
  }
  async handleGoToPrevPage() {
    this.loadingService.show();

    const prev = this.billetsPaginated ? this.billetsPaginated.pagination.page - 1 : 0;
    const paginationParams = new PaginationParams(prev, this.itemsPerPage)
    const {startDate, endDate, searchKey, status} = this.getValuesFromForm()
    await this.getBilletsWithFiler(startDate || this.startDateSelected, endDate, status, searchKey, paginationParams);
  }
}
